import React from 'react';
import { Button } from 'ui/button';
import { EditorEvent, EditorCommand } from '../../constants';
import { CommandManager } from '../../commands';
import { EditorContextProps, withEditorContext } from '../../hooks';

interface CommandButtonProps extends EditorContextProps {
  name: EditorCommand | string;
  className?: string;
  disabledClassName?: string;
  children: React.ReactNode;
}

class CommandButtonCmp extends React.Component<CommandButtonProps> {
  static defaultProps = {
    className: 'command',
    disabledClassName: 'command-disabled',
  };

  state = {
    disabled: false,
  };

  componentDidMount() {
    const { graph } = this.props;
    this.updateDisabledState();

    // @ts-ignore
    graph?.on(EditorEvent.onGraphStateChange, this.updateDisabledState);
    // @ts-ignore
    graph?.on('nodeselectchange', this.updateDisabledState);
  }

  componentWillUnmount() {
    const { graph } = this.props;
    graph?.off(EditorEvent.onGraphStateChange, this.updateDisabledState);
    graph?.off('nodeselectchange', this.updateDisabledState);
  }

  updateDisabledState = () => {
    const { graph, name } = this.props;
    const commandManager: CommandManager = graph?.get('commandManager');
    this.setState({
      disabled: !commandManager.canExecute(graph, name),
    });
  };

  handleClick = () => {
    const { name, executeCommand } = this.props;

    executeCommand(name);
  };

  render() {
    const { graph } = this.props;

    if (!graph) {
      return null;
    }

    const { children, ...rest } = this.props;
    const { disabled } = this.state;

    return (
      <Button onClick={this.handleClick} isDisabled={disabled} {...rest}>
        {children}
      </Button>
    );
  }
}

export const CommandButton = withEditorContext<CommandButtonProps>(CommandButtonCmp);
export default CommandButton;
